<template>
    <div class="mb-4">
        <FormField :field="form.account.fields.name" namespace="account" :name="'name'" class="mb-1" />
        <p v-if="state.total_similar_accounts" class="text-sm"><strong>Warning!</strong> {{state.total_similar_accounts}} similar account{{state.total_similar_accounts == 1 ? '' : 's'}} already exist{{state.total_similar_accounts == 1 ? 's' : ''}} for this auctioneer <button v-on:click="() => state.similar_accounts_modal_active = true" type="button" class="text-blue-500 font-medium">view similar accounts</button></p>

        <Modal v-on:close="() => state.similar_accounts_modal_active = false" :active="state.similar_accounts_modal_active" size="lg">
            <div class="lg:flex lg:items-center lg:justify-between mb-8">
                <h3 class="text-xl leading-6 font-medium text-gray-900">Similar Accounts</h3>
                <button type="button" v-on:click="() => state.similar_accounts_modal_active = false">
                    <CrossIcon class="h-6 w-6 text-gray-400" />
                </button>
            </div>

            <div>
                <ul role="list" class="divide-y divide-gray/5">
                    <li v-for="account in state.similar_accounts" :key="account.id" class="py-4">
                        <div class="flex items-center gap-x-3">
                            <h3 class="flex-auto truncate text-sm font-semibold text-gray-800" v-html="account.name"></h3>
                            <span class="flex-none text-xs text-gray-500"></span>
                        </div>
                        <p class="mt-1 truncate text-sm text-gray-500">{{ account.code }}</p>
                    </li>
                </ul>
            </div>

            <div class="pt-8">
                <Button :onClick="() => ROUTER.push({ name: 'accounts.index' })" type="button" color="red" class="mb-4">Cancel account creation</Button>
                <Button :onClick="() => state.similar_accounts_modal_active = false" type="button" color="text-blue">Close</Button>
            </div>

        </Modal>
    </div>
</template>

<script>
import {computed, watch, onMounted, reactive, ref} from 'vue'
import { useAccountStore } from "@sto/account.store"
import { useAuctioneerStore } from '@sto/auctioneer.store'
import { useRouter } from 'vue-router'
import {getConfigurationValue, isValidField} from '@lib/helpers'
import CrossIcon from "@ico/CrossIcon.vue";
import AssetAddToSale from "@par/asset/AssetAddToSale.vue";
import CheckCircleFillIcon from "@ico/CheckCircleFillIcon.vue";
export default {
    components: {CheckCircleFillIcon, AssetAddToSale, CrossIcon},
    props: ['auctioneer_id'],
    setup(props, {emit}) {

        const ACCOUNT_STORE = useAccountStore()
        const AUCTIONEER_STORE = useAuctioneerStore()
        const ROUTER = useRouter()

        const state = reactive({
            account_check_loading: false,
            account_check_timeout: null,
            account_check_min_length: 3,
            similar_accounts: [],
            total_similar_accounts: 0,
            similar_accounts_modal_active: false
        })

        const form = reactive({
            account: {
                loading: false,
                fields: {
                    name: {
                        active: true,
                        label: 'Account Name',
                        type: 'text',
                        value: '',
                        placeholder: '',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    },
                }
            }
        })

        const getSimilarAccounts = async () => {

            if (!props.auctioneer_id || form.account.fields.name.value.length < state.account_check_min_length || state.account_check_loading) return

            try {
                state.account_check_loading = true
                const similar_accounts = await ACCOUNT_STORE.list([{key: 'page', value: 1}, {key: 'auctioneer_id', value: props.auctioneer_id}, {key: 'search_string', value: form.account.fields.name.value}])
                state.similar_accounts = similar_accounts?.accounts || []
                state.total_similar_accounts = similar_accounts?.pagination?.total

            } catch (error) {
                console.error('ACCOUNT_STORE.list error', error)
                state.similar_accounts = []
                state.total_similar_accounts = 0
            } finally {
                state.account_check_loading = false
            }
        }

        watch (
            () => form.account.fields.name.value,
            (new_value) => {
                if (!props.auctioneer_id || form.account.fields.name.value.length < state.account_check_min_length) return
                if (state.account_check_timeout) clearTimeout(state.account_check_timeout)
                state.account_check_timeout = setTimeout(getSimilarAccounts, 300)

                emit('value_update', new_value)
            }
        )

        return {
            form,
            state,
            ROUTER
        }
    }
}
</script>